// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__gilroyMedium_46c72b', '__gilroyMedium_Fallback_46c72b'","fontWeight":500},"className":"__className_46c72b","variable":"__variable_46c72b"};